import { version } from '@nordhealth/themes/package.json'
import { useCurrentDir, useCurrentLocale } from '@/composables/i18next.js'
import { useAuth } from '@/composables/useAuth.js'
import { useTheme } from '@/composables/useTheme.js'
import useTranslation from '@/composables/useTranslation.js'

export function useProvetHead() {
  const route = useRoute()
  const t = useTranslation()
  const { theme, disableTransitions } = useTheme()
  const config = useRuntimeConfig()
  const { activeDepartment } = useAuth()
  const currentLocale = useCurrentLocale()
  const dir = useCurrentDir()

  const secondaryAccentColor = computed(
    () => activeDepartment.value?.attributes?.navbar_color,
  )

  return useHead({
    htmlAttrs: {
      lang: () => currentLocale.value,
      dir: () => dir.value,
      class: {
        'disable-transitions': () => disableTransitions.value,
        'n-reset': true,
      },
      style: () =>
        secondaryAccentColor.value
          ? `--n-color-accent-secondary: #${secondaryAccentColor.value}`
          : undefined,
    },
    meta: () => {
      const meta = []
      if (secondaryAccentColor.value) {
        meta.push({
          name: 'theme-color',
          content: `#${secondaryAccentColor.value}`,
        })
      }

      return meta
    },
    title: () => (route.meta.title ? t(route.meta.title).toString() : 'Provet'),
    link: [
      {
        'data-theme': 'vet',
        href: `${config.app.baseURL}themes/vet.css?v=${version}`,
        rel: 'stylesheet',
        // @ts-expect-error disabled prop isn't available in the Link declaration
        disabled: () => theme.value !== 'vet',
      },
      {
        'data-theme': 'vet-high-contrast',
        href: `${config.app.baseURL}themes/vet-high-contrast.css?v=${version}`,
        rel: 'stylesheet',
        // @ts-expect-error disabled prop isn't available in the Link declaration
        disabled: () => theme.value !== 'vet-high-contrast',
      },
      {
        'data-theme': 'vet-dark',
        href: `${config.app.baseURL}themes/vet-dark.css?v=${version}`,
        rel: 'stylesheet',
        // @ts-expect-error disabled prop isn't available in the Link declaration
        disabled: () => !theme.value.startsWith('vet-dark'),
      },
      {
        'data-theme': 'vet-dark-high-contrast',
        href: `${config.app.baseURL}themes/vet-dark-high-contrast.css?v=${version}`,
        rel: 'stylesheet',
        // @ts-expect-error disabled prop isn't available in the Link declaration
        disabled: () => theme.value !== 'vet-dark-high-contrast',
      },
    ],
  })
}
